<ul class="breadcrumb">
    <li><a [routerLink]="['/home']"><span class="color-soft-grey-axial">{{'general.breadcrumb.you_are' | translate}} </span>{{'general.breadcrumb.home' | translate}}</a></li>
    <li><i class="pi pi-angle-right"></i></li>
    <li><a [routerLink]="['/users']">{{'user.entity.name_plural'|translate}}</a></li>
</ul>
<app-view #view [code]="'users.list'" [model]="usersFilters" (onEvent)="onEvent($event)"></app-view>
